/**
 * Bottom Sheet Manager
 * Utility functions for managing bottom sheet state across the application
 */

/**
 * Get bottom sheet instance
 */
export function getBottomSheet() {
  return window.IPHUB_BOTTOM_SHEET || null;
}

/**
 * Check if bottom sheet is available
 */
export function isBottomSheetAvailable() {
  return !!window.IPHUB_BOTTOM_SHEET;
}

/**
 * Set bottom sheet state
 * @param {string} state - 'collapsed', 'expanded', or 'full'
 */
export function setBottomSheetState(state) {
  const bottomSheet = getBottomSheet();
  if (bottomSheet) {
    bottomSheet.setState(state);
  }
}

/**
 * Expand bottom sheet (equivalent to old setLevel(1))
 */
export function expandBottomSheet() {
  setBottomSheetState("expanded");
}

/**
 * Collapse bottom sheet (equivalent to old setLevel(0))
 */
export function collapseBottomSheet() {
  setBottomSheetState("collapsed");
}

/**
 * Full screen bottom sheet (equivalent to old setLevel(2))
 */
export function fullScreenBottomSheet() {
  setBottomSheetState("full");
}

/**
 * Toggle bottom sheet between collapsed and expanded
 */
export function toggleBottomSheet() {
  const bottomSheet = getBottomSheet();
  if (bottomSheet) {
    const currentState = bottomSheet.getState();
    if (currentState === "collapsed") {
      bottomSheet.setState("expanded");
    } else {
      bottomSheet.setState("collapsed");
    }
  }
}
